import React from 'react';
import { Controller } from 'react-hook-form';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { parse, isValid, format } from 'date-fns';

const RHFTimePicker = ({ control, name, rules, label, onChange: onChangeProp, ...rest }) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TimePicker
                ampm={false}
                label={label}
                value={value ? parse(value, 'HH:mm', new Date()) : null}
                onChange={(val) => {
                    const formatted = val && isValid(val) ? format(val, 'HH:mm') : null;
                    onChange(formatted);
                    if (onChangeProp) onChangeProp(formatted);
                }}
                format="HH:mm"
                slotProps={{
                    textField: {
                        error: !!error,
                        helperText: error?.message,
                        InputProps: {
                            style: { color: value ? 'inherit' : '#9c9c9c' },
                        },
                    },
                    actionBar: {
                        actions: ['clear', 'cancel', 'accept'],
                    },
                }}
                {...rest}
            />
        )}
    />
);

export default RHFTimePicker;